// extracted by mini-css-extract-plugin
module.exports = {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","menuHeader":"#f9f9fa","SearchResults":"jr_a bhe_a bhe_j bhe_q bhe_rp bhe_rq bhe_w"};